import BulkMailLayout from "../pages/BulkMail";
import StaticEmailTemplates from "../container/StaticEmailTemplates/StaticEmailTemplates";
import ComposeMail from "../container/ComposeMail/ComposeMail";
import EmailLogs from "../container/EmailLogs/EmailLogs";
import EditTemplate from "../container/EditTemplate/EditTemplate";

const BulkMailRoutes = [
  {
    path: "bulk-email",
    element: <BulkMailLayout />, 
    children: [
      { path: "static-email", element: <StaticEmailTemplates /> },
      { path: "compose-email", element: <ComposeMail /> },
      { path: "emaillogs", element: <EmailLogs /> },
      { path: "static-email/edit/:templateId", element: <EditTemplate /> },
      { path: "compose-email/edit/:templateId", element: <EditTemplate /> },
    ],
  },
];

export default BulkMailRoutes;
